import { ConditionDetailNotes } from 'types';

export const CDN_CASE_DEFINITION = 'case_definition';
export const CDN_NON_FATAL_ICD9_CODES = 'non_fatal_icd9_codes';
export const CDN_NON_FATAL_ICD10_CODES = 'non_fatal_icd10_codes';
export const CDN_FATAL_ICD9_CODES = 'fatal_icd9_codes';
export const CDN_FATAL_ICD10_CODES = 'fatal_icd10_codes';
export const CDN_NOTES = 'notes';

export const CONDITION_DETAIL_NOTES: (keyof ConditionDetailNotes)[] = [
    'quantity_of_interest',
    'is_reference_definition',
    'reference_id',
    CDN_CASE_DEFINITION,
    'parent_case_definition',
    'exclusion_criteria',
    'has_inpatient',
    'has_outpatient',
    'has_primary_care',
    'has_claims',
    'has_survey',
    'has_disease_registry',
    'has_case_notification',
    'has_cohort_study',
    'has_intervention_study',
    'has_case_control_study',
    'has_case_series',
    'has_self_report',
    'has_physical_biomarker',
    'has_direct_observation',
    'has_physician_diagnosis',
    'has_physical_monitoring',
    'has_other_source_types',
    'other_source_type_notes',
    CDN_NON_FATAL_ICD9_CODES,
    CDN_NON_FATAL_ICD10_CODES,
    CDN_FATAL_ICD9_CODES,
    CDN_FATAL_ICD10_CODES,
    'non_fatal_female_age_group_restriction_ids',
    'non_fatal_male_age_group_restriction_ids',
    'fatal_female_age_group_restriction_ids',
    'fatal_male_age_group_restriction_ids',
    'non_fatal_location_restriction_ids',
    'fatal_location_restriction_ids',
    'fatal_data_source_link',
    'non_fatal_data_source_link',
    CDN_NOTES,
];
